import GenericFormModalContainer from "../../../../components/TailwindControls/Modals/FormModal/GenericFormModalContainer";
import Lottie from "lottie-react";
import { TextLoop } from "../../../../components/TailwindControls/TextLoop/TextLoop";
import React from "react";
import {
  applicationLogo,
  applicationName,
  instanceAddProcessingAnimation,
  instanceAddProcessingImage,
} from "../../../../shared/themeHelper/themeHelperfunc";
import { useBaseDomain } from "../../../../shared/context/RuntimeConfigContext";

export function InstanceAddProcessing(props: {
  renderFullPage: boolean;
  messages: string[];
}) {
  const baseDomain = useBaseDomain();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: instanceAddProcessingAnimation(baseDomain),
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <GenericFormModalContainer
      topIconType="None"
      renderFullPage={props.renderFullPage}
    >
      <div className="w-full h-full flex flex-col items-center">
        <span className="font-bold text-xl text-vryno-label-gray mb-4">
          Almost there
        </span>
        <div className="flex flex-col items-center justify-center">
          <img
            src={instanceAddProcessingImage(baseDomain)}
            alt="laptop"
            className="w-48"
          />
          <img
            src={applicationLogo(baseDomain)}
            alt={`${applicationName(baseDomain)} Icon`}
            className="w-8 absolute"
          />
          <div className="absolute">
            <Lottie
              animationData={defaultOptions.animationData}
              loop={defaultOptions.loop}
              autoplay={defaultOptions.autoplay}
              rendererSettings={defaultOptions.rendererSettings}
              style={{ height: "120px", width: "120px" }}
            />
          </div>
        </div>
        <TextLoop messages={props.messages} />
      </div>
    </GenericFormModalContainer>
  );
}
